import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';
import isEmpty from 'lodash/isEmpty';

const doListIssues = async () => {
  return await SuperFetch.post(apiUrls.getLandlordIssueReports)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* listIssues() {
  const response = yield call(doListIssues);
  if (response.reports && !isEmpty(response.reports)) {
    yield put(actions.doListIssuesSuccess(response.reports))
  } else {
    yield put(actions.doListIssuesFailed(response))
  }
}

const doGetIssueDetails = async hash => {
  const body = {
    data: { hash }
  }
  return await SuperFetch.post(`${apiUrls.getIssueReport}?includeThread=1`, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
const doGetIssueThread = async threadHash => {
  const body = {
    data: {
      threadHash: threadHash.threadHash
    }
  }
  return await SuperFetch.post(`${apiUrls.getInboxV2}Thread/1/notarchived/category-issue`, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};
export function* getIssueDetails(action) {
  const response = yield call(doGetIssueDetails, action.payload);

  if ( response && !isEmpty(response) ) {

    if (response.issue.messageThreadHash) {
      const payload = {
        threadHash: response.issue.messageThreadHash
      }
      const thread = yield call(doGetIssueThread, payload);
      if (!isEmpty(thread)) {
        response.inbox = thread.inbox;
      }
    }
    yield put(actions.doGetIssueDetailsSuccess(response));
  } else {
    yield put(actions.doGetIssueDetailsFailed(response));
  }
}

const doResolveIssue = async hash => {
  const body = {
    data: { hash }
  }
  return await SuperFetch.post(apiUrls.landlordResolveIssue, body)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
}
export function* resolveIssue(action) {
  const response = yield call(doResolveIssue, action.payload);
  if ( response && !isEmpty(response) && !response.error ) {
    yield put(actions.doResolveIssueSuccess(response));
    yield put(actions.doGetIssueDetails(action.payload));
  } else {
    yield put(actions.doResolveIssueFailed({message: 'Failed to resolve issue'}));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DO_LIST_ISSUES, listIssues),
    takeEvery(actions.DO_GET_ISSUE_DETAILS, getIssueDetails),
    takeEvery(actions.DO_RESOLVE_ISSUE, resolveIssue)
  ]);
}


// WEBPACK FOOTER //
// ./src/redux/issues/sagas.js